import { 
  doc, 
  updateDoc,
  serverTimestamp
} from 'firebase/firestore';
import { db } from '@/lib/firebase';
import { generateEvaluatorDocId } from './evaluator/utils';
import { checkAndAutoFinalizeEvaluators } from './evaluator/autoFinalize';

export async function handleEvaluationSubmission(evaluatorId: string, userId: string): Promise<void> {
  if (!evaluatorId || !userId) {
    throw new Error('Evaluator ID and User ID are required');
  }

  try {
    const docId = generateEvaluatorDocId(evaluatorId, userId);
    const evaluatorRef = doc(db, 'evaluators', docId);

    await updateDoc(evaluatorRef, {
      evaluationCompleted: true,
      evaluationCompletedAt: serverTimestamp(),
      updatedAt: serverTimestamp()
    });

    // Check for auto-finalization after evaluation submission
    await checkAndAutoFinalizeEvaluators(userId);
  } catch (error: any) {
    console.error('Error submitting evaluation:', error);
    throw new Error(error.message || 'Failed to submit evaluation');
  }
}